export default __webpack_public_path__ + "static/media/drag-lines.a7e044b2.svg";